(function () {
  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function isMobileViewport() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  /*
   * Figma reference frame: 1728 x 1060, images 350 x 380.
   * We store START (clustered) and END (corners) as the CENTER point of each
   * tile, expressed as a % of the frame -- so it scales to any stage size.
   * center% = (left + width/2) / frameW * 100  (same for vertical)
   */
  var FRAME_W = 1728;
  var FRAME_H = 1060;
  var IMG_W = 350;
  var IMG_H = 380;

  function centerPct(left, top) {
    return {
      cx: ((left + IMG_W / 2) / FRAME_W) * 100,
      cy: ((top + IMG_H / 2) / FRAME_H) * 100,
    };
  }

  // START -- clustered overlap (left Figma frame)
  var START = {
    tl: centerPct(544, 203),
    tr: centerPct(836, 263),
    bl: centerPct(501, 438),
    br: centerPct(821, 477),
  };

  // END -- corners flush to the section edges.
  // Outer edge of each tile sits at the frame edge:
  //   left tiles  -> left: 0          => center cx = (IMG_W/2)/FRAME_W
  //   right tiles -> right: 0         => center cx = (FRAME_W - IMG_W/2)/FRAME_W
  //   top tiles   -> top: 0           => center cy = (IMG_H/2)/FRAME_H
  //   bottom tiles-> bottom: 0        => center cy = (FRAME_H - IMG_H/2)/FRAME_H
  var END = {
    tl: centerPct(0, 0),
    tr: centerPct(FRAME_W - IMG_W, 0),
    bl: centerPct(0, FRAME_H - IMG_H),
    br: centerPct(FRAME_W - IMG_W, FRAME_H - IMG_H),
  };

  function init(root) {
    var track = root.querySelector(".wbw__track");
    var stage = root.querySelector(".wbw__stage");
    var content = root.querySelector("[data-wbw-content]");
    var photos = root.querySelectorAll("[data-wbw-photo]");
    if (!track || !stage || !photos.length) return;

    var reduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function applyMobileStatic() {
      root.classList.remove("wbw--corners");
      photos.forEach(function (el) {
        el.removeAttribute("data-wbw-mode");
        el.style.removeProperty("--cx");
        el.style.removeProperty("--cy");
        el.style.setProperty("--s", "1");
      });
      if (content) content.style.setProperty("--content-o", "1");
    }

    function applyDesktopProgress(p) {
      p = clamp(p, 0, 1);
      var t = reduced ? 1 : easeInOutCubic(p);

      // Text fades in across the middle of the scroll
      if (content) {
        content.style.setProperty(
          "--content-o",
          String(reduced ? 1 : clamp((p - 0.15) / 0.5, 0, 1))
        );
      }

      // Live stage size, so the flush-edge end is exact on any viewport.
      var sr = stage.getBoundingClientRect();
      var S = sr.width || 1;
      var H = sr.height || 1;

      photos.forEach(function (el) {
        var key = el.getAttribute("data-wbw-photo");
        var s = START[key] || START.tl;

        // Actual rendered tile size (set by CSS), as % of the stage.
        var tw = el.offsetWidth || S * 0.2025;
        var th = el.offsetHeight || tw * (IMG_H / IMG_W);
        var halfWpct = (tw / 2 / S) * 100;
        var halfHpct = (th / 2 / H) * 100;

        // Flush-to-edge center positions for each corner.
        var endCx =
          key === "tr" || key === "br" ? 100 - halfWpct : halfWpct;
        var endCy =
          key === "bl" || key === "br" ? 100 - halfHpct : halfHpct;

        var cx = lerp(s.cx, endCx, t);
        var cy = lerp(s.cy, endCy, t);

        el.setAttribute("data-wbw-mode", "center");
        el.style.setProperty("--cx", cx.toFixed(4));
        el.style.setProperty("--cy", cy.toFixed(4));
        el.style.setProperty("--s", "1"); // size handled by CSS width
      });
    }

    function scrollProgress() {
      var rect = track.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var total = rect.height - vh;
      if (total <= 0) {
        return rect.top > vh * 0.15 ? 0 : 1;
      }
      return clamp(-rect.top / total, 0, 1);
    }

    // ---- Smoothing loop: rendered progress eases toward scroll target ----
    var renderedP = null;
    var targetP = 0;
    var rafId = null;
    var SMOOTHING = 0.06; // lower = slower / smoother follow

    function animate() {
      if (renderedP === null) renderedP = targetP;
      var diff = targetP - renderedP;
      if (reduced || Math.abs(diff) < 0.0005) {
        renderedP = targetP;
        applyDesktopProgress(renderedP);
        rafId = null;
        return;
      }
      renderedP += diff * SMOOTHING;
      applyDesktopProgress(renderedP);
      rafId = requestAnimationFrame(animate);
    }

    function tick() {
      if (isMobileViewport()) {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        renderedP = null;
        applyMobileStatic();
        return;
      }
      targetP = scrollProgress();
      if (rafId === null) rafId = requestAnimationFrame(animate);
    }

    window.addEventListener("scroll", tick, { passive: true });
    window.addEventListener("resize", tick);
    tick();

    document.addEventListener("shopify:section:load", function (ev) {
      if (ev.target && ev.target.contains && ev.target.contains(root)) tick();
    });
  }

  document.querySelectorAll("[data-wood-behind-work]").forEach(init);
})();